export default class Fixedcontact {
    constructor(element) {
      this.el = element
      this.title = this.el.querySelector('[data-title]')
      this.content = this.el.querySelector('[data-content]')
      this.linkTop = this.el.querySelector('[data-toplink]')
      this.linkBottom = this.el.querySelector('[data-bottomlink]')
      this.extraLink = this.el.querySelector('[data-extralink]')
      this.facebookLink = this.el.querySelector('[data-facebooklink]')
      this.extractcontent = this.extractcontent.bind(this)
      this.init()
      
    }
    
    init() {
      
      this.extractcontent();      
      
  	// Init ScrollMagic
	var controller = new ScrollMagic.Controller()

	// build a scene
	var slidein = new ScrollMagic.Scene({
    triggerElement: '.contact-static',
    offset: '1050',
    reverse: true,
    
	})
    .setClassToggle('.contact-fixed', 'fade-in') // add class to project01 

  .addTo(controller)
  
  // build a scene
	var slideout = new ScrollMagic.Scene({
    triggerElement: 'footer',
    offset: '-450',
    reverse: true
	})
    .setClassToggle('.contact-fixed', 'fade-out') // add class to project01
    

	.addTo(controller)

}

extractcontent() {
  const insertLinkTop = this.linkTop.innerHTML
  const insertLinkBottom = this.linkBottom.innerHTML
  const insertTitle = this.title.innerHTML
  // const insertExtraLink = this.extraLink.innerHTML
  const fixedContact = `
  <section class="container-fluid contact-fixed theme-light-solid">
  <div class="row">
      <div class="col-md-4 col-xs-2 col-sm-2">
        <div class="fixed-contact-column1">
          ${insertTitle}
        </div>
      </div>
      <div class="col-md-2 col-md-offset-1 col-xs-2 col-sm-3 col-sm-offset-2">
        <div class="fixed-contact-column2">
          ${insertLinkTop}
        </div>
      </div>
      <div class="col-md-3 col-md-offset-2 col-xs-2 col-sm-4 col-sm-offset-1">
        <div class="fixed-contact-column3">
          ${insertLinkBottom}
          
        </div>
      
  </div>
  </section>
  `
  console.log(fixedContact);
  document.body.insertAdjacentHTML('beforeend', fixedContact);
 }

}